module.exports = {
      id: "comm-technology-usage",
      viewBox: "0 0 366.545 49.888",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#comm-technology",
      toString: function () {
        return this.url;
      }
    }